// import { useEffect, useRef } from 'react';

// const DevToolsPasswordGuard = ({ devToolsPassword }) => {
//     const accessGranted = useRef(false);
//     const alreadyPrompted = useRef(false);

//     useEffect(() => {
//         const detectDevTools = () => {
//             const threshold = 160;
//             const devToolsOpen =
//                 window.outerWidth - window.innerWidth > threshold ||
//                 window.outerHeight - window.innerHeight > threshold;

//             if (devToolsOpen && !accessGranted.current && !alreadyPrompted.current) {
//                 alreadyPrompted.current = true;

//                 const input = prompt('🔒 Enter password to access DevTools:');
//                 if (input !== devToolsPassword) {
//                     alert('❌ Wrong password. Redirecting...');
//                     window.location.href = 'https://www.google.com';
//                 } else {
//                     accessGranted.current = true;
//                 }
//             }
//         };

//         const interval = setInterval(detectDevTools, 1000);

//         const onKeyDown = (e) => {
//             if (
//                 e.key === 'F12' ||
//                 (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J'))
//             ) {
//                 e.preventDefault();
//                 detectDevTools();
//             }
//         };

//         window.addEventListener('keydown', onKeyDown);
//         return () => {
//             clearInterval(interval);
//             window.removeEventListener('keydown', onKeyDown);
//         };
//     }, [devToolsPassword]);

//     return null;
// };

// export default DevToolsPasswordGuard;
